import { MultiselectItem } from '@ui/aos-lib';
import { TranslateRegistry } from 'src/app/services/translate/translate.registry';
import { FilterModel } from 'src/app/shared/components/listing-page/services/listing-page-model/listing-page-model.types';

export type ReportGroupsFilter = Omit<FilterModel, 'filterType' | 'title' | 'width' | 'isMultiselect'>;

export interface ReportGroupsFilterOptions {
  filterType?: string;
  removeButtonDisabled?: boolean;
  removeButtonTooltip?: string;
}

export interface ReportGroupsFilterForm {
  name: MultiselectItem;
  operator?: MultiselectItem;
  values?: string | number[];
  options?: ReportGroupsFilterOptions;
}

export interface FilterFieldMap {
  [key: string]: MultiselectItem & { fieldName: string; attributeType: 'Device' };
}

export const FilterFieldMapping: FilterFieldMap = {
  DeviceUID: {
    text: TranslateRegistry.get.CREATE_EDIT_REPORT_GROUP.FILTER_OPTION.LASSO_TOOL,
    value: 'DeviceUID',
    subcategory: TranslateRegistry.get.CREATE_EDIT_REPORT_GROUP.FILTER_GROUP.LASSO_TOOL,
    fieldName: 'DeviceUID',
    attributeType: 'Device'
  },
  CustomerNumber: {
    text: TranslateRegistry.get.CREATE_EDIT_REPORT_GROUP.FILTER_OPTION.CUSTOMER_NUMBER,
    value: 'CustomerNumber',
    subcategory: TranslateRegistry.get.CREATE_EDIT_REPORT_GROUP.FILTER_GROUP.CUSTOMER,
    fieldName: 'CustomerNumber',
    attributeType: 'Device'
  },
  CustomerType: {
    text: TranslateRegistry.get.CREATE_EDIT_REPORT_GROUP.FILTER_OPTION.CUSTOMER_TYPE,
    value: 'CustomerType',
    subcategory: TranslateRegistry.get.CREATE_EDIT_REPORT_GROUP.FILTER_GROUP.CUSTOMER,
    fieldName: 'CustomerType',
    attributeType: 'Device'
  },
  AccountNumber: {
    text: TranslateRegistry.get.CREATE_EDIT_REPORT_GROUP.FILTER_OPTION.ACCOUNT_NUMBER,
    value: 'AccountNumber',
    subcategory: TranslateRegistry.get.CREATE_EDIT_REPORT_GROUP.FILTER_GROUP.ACCOUNT,
    fieldName: 'AccountNumber',
    attributeType: 'Device'
  },
  AccountStatus: {
    text: TranslateRegistry.get.CREATE_EDIT_REPORT_GROUP.FILTER_OPTION.ACCOUNT_STATUS,
    value: 'AccountStatus',
    subcategory: TranslateRegistry.get.CREATE_EDIT_REPORT_GROUP.FILTER_GROUP.ACCOUNT,
    fieldName: 'AccountStatus',
    attributeType: 'Device'
  },
  AccountStatusChangeDate: {
    text: TranslateRegistry.get.CREATE_EDIT_REPORT_GROUP.FILTER_OPTION.ACCOUNT_STATUS_CHANGED_DATE,
    value: 'AccountStatusChangeDate',
    subcategory: TranslateRegistry.get.CREATE_EDIT_REPORT_GROUP.FILTER_GROUP.ACCOUNT,
    fieldName: 'AccountStatusChangeDate',
    attributeType: 'Device'
  },
  Cycle: {
    text: TranslateRegistry.get.CREATE_EDIT_REPORT_GROUP.FILTER_OPTION.BILL_CYCLE,
    value: 'Cycle',
    subcategory: TranslateRegistry.get.CREATE_EDIT_REPORT_GROUP.FILTER_GROUP.SERVICE,
    fieldName: 'Cycle',
    attributeType: 'Device'
  },
  Book: {
    text: TranslateRegistry.get.CREATE_EDIT_REPORT_GROUP.FILTER_OPTION.BOOK,
    value: 'Book',
    subcategory: TranslateRegistry.get.CREATE_EDIT_REPORT_GROUP.FILTER_GROUP.SERVICE,
    fieldName: 'Book',
    attributeType: 'Device'
  },
  PriorityTypeCritical: {
    text: TranslateRegistry.get.CREATE_EDIT_REPORT_GROUP.FILTER_OPTION.PRIORITY_TYPE_CRITICAL,
    value: 'PriorityTypeCritical',
    subcategory: TranslateRegistry.get.CREATE_EDIT_REPORT_GROUP.FILTER_GROUP.SERVICE,
    fieldName: 'PriorityTypeCritical',
    attributeType: 'Device'
  },
  PriorityTypesOthers: {
    text: TranslateRegistry.get.CREATE_EDIT_REPORT_GROUP.FILTER_OPTION.PRIORITY_TYPE_OTHERS,
    value: 'PriorityTypesOthers',
    subcategory: TranslateRegistry.get.CREATE_EDIT_REPORT_GROUP.FILTER_GROUP.SERVICE,
    fieldName: 'PriorityTypesOthers',
    attributeType: 'Device'
  },
  RateClass: {
    text: TranslateRegistry.get.CREATE_EDIT_REPORT_GROUP.FILTER_OPTION.RATE_CLASS,
    value: 'RateClass',
    subcategory: TranslateRegistry.get.CREATE_EDIT_REPORT_GROUP.FILTER_GROUP.SERVICE,
    fieldName: 'RateClass',
    attributeType: 'Device'
  },
  RevenueClass: {
    text: TranslateRegistry.get.CREATE_EDIT_REPORT_GROUP.FILTER_OPTION.REVENUE_CLASS,
    value: 'RevenueClass',
    subcategory: TranslateRegistry.get.CREATE_EDIT_REPORT_GROUP.FILTER_GROUP.SERVICE,
    fieldName: 'RevenueClass',
    attributeType: 'Device'
  },
  ServiceEndDate: {
    text: TranslateRegistry.get.CREATE_EDIT_REPORT_GROUP.FILTER_OPTION.SERVICE_END_DATE,
    value: 'ServiceEndDate',
    subcategory: TranslateRegistry.get.CREATE_EDIT_REPORT_GROUP.FILTER_GROUP.SERVICE,
    fieldName: 'ServiceEndDate',
    attributeType: 'Device'
  },
  ServiceStartDate: {
    text: TranslateRegistry.get.CREATE_EDIT_REPORT_GROUP.FILTER_OPTION.SERVICE_START_DATE,
    value: 'ServiceStartDate',
    subcategory: TranslateRegistry.get.CREATE_EDIT_REPORT_GROUP.FILTER_GROUP.SERVICE,
    fieldName: 'ServiceStartDate',
    attributeType: 'Device'
  },
  ServiceStatus: {
    text: TranslateRegistry.get.CREATE_EDIT_REPORT_GROUP.FILTER_OPTION.SERVICE_STATUS,
    value: 'ServiceStatus',
    subcategory: TranslateRegistry.get.CREATE_EDIT_REPORT_GROUP.FILTER_GROUP.SERVICE,
    fieldName: 'ServiceStatus',
    attributeType: 'Device'
  },
  ServiceType: {
    text: TranslateRegistry.get.CREATE_EDIT_REPORT_GROUP.FILTER_OPTION.SERVICE_TYPE,
    value: 'ServiceType',
    subcategory: TranslateRegistry.get.CREATE_EDIT_REPORT_GROUP.FILTER_GROUP.SERVICE,
    fieldName: 'ServiceType',
    attributeType: 'Device'
  },
  ServiceAddress1: {
    text: TranslateRegistry.get.CREATE_EDIT_REPORT_GROUP.FILTER_OPTION.ADDRESS_1,
    value: 'ServiceAddress1',
    subcategory: TranslateRegistry.get.CREATE_EDIT_REPORT_GROUP.FILTER_OPTION.SERVICE_ADDRESS,
    fieldName: 'ServiceAddress1',
    attributeType: 'Device'
  },
  ServiceAddress2: {
    text: TranslateRegistry.get.CREATE_EDIT_REPORT_GROUP.FILTER_OPTION.ADDRESS_2,
    value: 'ServiceAddress2',
    subcategory: TranslateRegistry.get.CREATE_EDIT_REPORT_GROUP.FILTER_OPTION.SERVICE_ADDRESS,
    fieldName: 'ServiceAddress2',
    attributeType: 'Device'
  },
  ServiceCity: {
    text: TranslateRegistry.get.CREATE_EDIT_REPORT_GROUP.FILTER_OPTION.CITY,
    value: 'ServiceCity',
    subcategory: TranslateRegistry.get.CREATE_EDIT_REPORT_GROUP.FILTER_OPTION.SERVICE_ADDRESS,
    fieldName: 'ServiceCity',
    attributeType: 'Device'
  },
  ServiceState: {
    text: TranslateRegistry.get.CREATE_EDIT_REPORT_GROUP.FILTER_OPTION.STATE,
    value: 'ServiceState',
    subcategory: TranslateRegistry.get.CREATE_EDIT_REPORT_GROUP.FILTER_OPTION.SERVICE_ADDRESS,
    fieldName: 'ServiceState',
    attributeType: 'Device'
  },
  ServiceZipCode: {
    text: TranslateRegistry.get.CREATE_EDIT_REPORT_GROUP.FILTER_OPTION.ZIP_CODE,
    value: 'ServiceZipCode',
    subcategory: TranslateRegistry.get.CREATE_EDIT_REPORT_GROUP.FILTER_OPTION.SERVICE_ADDRESS,
    fieldName: 'ServiceZipCode',
    attributeType: 'Device'
  },
  CommDeviceId: {
    text: TranslateRegistry.get.CREATE_EDIT_REPORT_GROUP.FILTER_OPTION.COMM_DEVICE_ID,
    value: 'CommDeviceId',
    subcategory: TranslateRegistry.get.CREATE_EDIT_REPORT_GROUP.FILTER_GROUP.DEVICE,
    fieldName: 'CommDeviceId',
    attributeType: 'Device'
  },
  Commodity: {
    text: TranslateRegistry.get.CREATE_EDIT_REPORT_GROUP.FILTER_OPTION.COMMODITY,
    value: 'Commodity',
    subcategory: TranslateRegistry.get.CREATE_EDIT_REPORT_GROUP.FILTER_GROUP.DEVICE,
    fieldName: 'Commodity',
    attributeType: 'Device'
  },
  DateLastAddedUTC: {
    text: TranslateRegistry.get.CREATE_EDIT_REPORT_GROUP.FILTER_OPTION.DEVICE_INSTALLATION_DATE,
    value: 'DateLastAddedUTC',
    subcategory: TranslateRegistry.get.CREATE_EDIT_REPORT_GROUP.FILTER_GROUP.DEVICE,
    fieldName: 'DateLastAddedUTC',
    attributeType: 'Device'
  },
  Status: {
    text: TranslateRegistry.get.CREATE_EDIT_REPORT_GROUP.FILTER_OPTION.DEVICE_STATUS,
    value: 'Status',
    subcategory: TranslateRegistry.get.CREATE_EDIT_REPORT_GROUP.FILTER_GROUP.DEVICE,
    fieldName: 'Status',
    attributeType: 'Device'
  },
  DeviceType: {
    text: TranslateRegistry.get.CREATE_EDIT_REPORT_GROUP.FILTER_OPTION.DEVICE_TYPE,
    value: 'DeviceType',
    subcategory: TranslateRegistry.get.CREATE_EDIT_REPORT_GROUP.FILTER_GROUP.DEVICE,
    fieldName: 'DeviceType',
    attributeType: 'Device'
  },
  Model: {
    text: TranslateRegistry.get.CREATE_EDIT_REPORT_GROUP.FILTER_OPTION.MODEL,
    value: 'ModelDescription',
    subcategory: TranslateRegistry.get.CREATE_EDIT_REPORT_GROUP.FILTER_GROUP.DEVICE,
    fieldName: 'ModelDescription',
    attributeType: 'Device'
  },
  ModelType: {
    text: TranslateRegistry.get.CREATE_EDIT_REPORT_GROUP.FILTER_OPTION.MODEL_TYPE,
    value: 'ModelType',
    subcategory: TranslateRegistry.get.CREATE_EDIT_REPORT_GROUP.FILTER_GROUP.DEVICE,
    fieldName: 'ModelType',
    attributeType: 'Device'
  },
  PortNumber: {
    text: TranslateRegistry.get.CREATE_EDIT_REPORT_GROUP.FILTER_OPTION.PORT_NUMBER,
    value: 'PortNumber',
    subcategory: TranslateRegistry.get.CREATE_EDIT_REPORT_GROUP.FILTER_GROUP.DEVICE,
    fieldName: 'PortNumber',
    attributeType: 'Device'
  },
  SerialNumber: {
    text: TranslateRegistry.get.CREATE_EDIT_REPORT_GROUP.FILTER_OPTION.SERIAL_NUMBER,
    value: 'SerialNumber',
    subcategory: TranslateRegistry.get.CREATE_EDIT_REPORT_GROUP.FILTER_GROUP.DEVICE,
    fieldName: 'SerialNumber',
    attributeType: 'Device'
  }
};
